var map = {
	"./3VMR-1920-1934.png": 1486,
	"./Esri_Word_Imagery.png": 1487,
	"./LIO_Imagery.png": 1488,
	"./LIO_Topo.png": 1489,
	"./Seismic_Hazard.png": 1490,
	"./Simple_Background.png": 1491,
	"./__globe-icon.png": 1492,
	"./__target.png": 1493,
	"./_globe-icon.png": 1494,
	"./_target.png": 1495,
	"./about.png": 1496,
	"./arrow-down.png": 1497,
	"./arrow-down2.png": 1498,
	"./arrow_curve.gif": 1499,
	"./blank-background.png": 1500,
	"./bm-bezpodkladu.jpg": 1501,
	"./bm-dmp+orto.png": 1502,
	"./bm-geologia.png": 1503,
	"./bm-kataster.png": 1504,
	"./bm-openstreetmap.jpeg": 1505,
	"./bm-ortofoto.png": 1506,
	"./bm-ortofoto2000.png": 1507,
	"./bm-ortofoto2009.png": 1508,
	"./bm-ortofoto2017.png": 1509,
	"./bm-vhm.png": 1510,
	"./bm-zbgis.png": 1511,
	"./bm-zm10.png": 1512,
	"./bm-zm25.png": 1513,
	"./bm-zm50.png": 1514,
	"./capture.png": 1515,
	"./compass.png": 1516,
	"./copy16.png": 1517,
	"./down.png": 1518,
	"./emergency.png": 1519,
	"./esri-streets.png": 1520,
	"./esri-topo.png": 1521,
	"./extent-zoom-in.png": 1522,
	"./feedback-footer.png": 1523,
	"./feedback.png": 1524,
	"./globe-icon.png": 1525,
	"./help.png": 1526,
	"./identify-marker.png": 1527,
	"./identify.png": 1528,
	"./identify_cursor.png": 1529,
	"./information.png": 1530,
	"./legend-footer.png": 1531,
	"./legend.png": 1532,
	"./lio-topo.png": 1533,
	"./loading.gif": 1534,
	"./measure.png": 1535,
	"./menu.png": 1536,
	"./metadata.png": 1537,
	"./more-options.png": 1538,
	"./myMaps.png": 1539,
	"./osm-topo.jpg": 1540,
	"./other.png": 1541,
	"./pdf.png": 1542,
	"./popup-icon.png": 1543,
	"./popup-icon_.png": 1544,
	"./print.png": 1545,
	"./school.png": 1546,
	"./screenshot.png": 1547,
	"./settings.png": 1548,
	"./tab-close.png": 1549,
	"./tab-open.png": 1550,
	"./target.png": 1551,
	"./terms-footer.png": 1552,
	"./terms.png": 1553,
	"./themes.png": 1554,
	"./tools.png": 1555,
	"./topo-blank.png": 1556,
	"./up.png": 1557,
	"./vtm-10000-1957-1971.png": 1558,
	"./vtm-25000-1952-1957.png": 1559,
	"./vtm-5000-1955-1961.png": 1560,
	"./waste.png": 1561,
	"./zoom-in.png": 1562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 336;